import { useState, useCallback, useEffect } from 'react';

type ConsentStatus = 'accepted' | 'declined' | null;

const STORAGE_KEY = 'logpulse-cookie-consent';
const GTM_ID = 'GTM-K6RNM85T';

function getStoredConsent(): ConsentStatus {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'accepted' || stored === 'declined') return stored;
  return null;
}

function loadGTM() {
  if (document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

export function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentStatus>(getStoredConsent);

  useEffect(() => {
    if (consent === 'accepted') {
      loadGTM();
    }
  }, [consent]);

  const accept = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setConsent('accepted');
  }, []);

  const decline = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setConsent('declined');
  }, []);

  return { consent, accept, decline };
}
